import React from 'react';
import { Empty } from 'antd';
import styles from '@pages/api-portal/styles.module.scss';
import { BodyCodeBlock } from './body-code-block';
import { getStatusMeta } from '@pages/api-portal/utils';
import { ResponseExample } from '@pages/api-portal/types';

interface ResponseExamplesProps {
    responses: ResponseExample[];
}

/*
 * Renders the Responses tab: one card per documented HTTP status with its example body.
 */
export function ResponseExamples({ responses }: ResponseExamplesProps) {
    if (!responses || responses.length === 0) {
        return <Empty description="This endpoint has no documented response examples." />;
    }

    return (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
            {responses.map((response, index) => {
                const { color, background, label } = getStatusMeta(response.status);
                const pillStyle = { background };
                return (
                    <div key={index} className={styles.card}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                                <span className={styles.badge} style={pillStyle}>
                                    <span className={styles.badgeDotInline} style={{ background: color }} />
                                    {response.status}
                                </span>
                                <span style={{ color: '#fff', fontSize: 14 }}>{response.description}</span>
                            </div>
                            <span className={styles.badge} style={pillStyle}>
                                <span className={styles.badgeDotInline} style={{ background: color }} />
                                {label}
                            </span>
                        </div>
                        <div className={styles.cardDivider} />
                        <BodyCodeBlock label="Response Body" data={response.example} />
                    </div>
                );
            })}
        </div>
    );
}
